import React, { useEffect, useState } from 'react';
import { DataContext } from '../../../Context/DataContext';
// import 'antd/dist/antd.css';
import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './InviteInfoFns'
import './InviteInfo.scss';
import moment from 'moment';


function InviteInfo(props) {    
const { globalData } = React.useContext(DataContext)
    const navigate = useNavigate()
    const location = useLocation()
    const { TextArea } = Input
    const [inviteInfo, setInviteInfo] = useState({})
    const [isPageLoading, setIsPageLoading] = useState(true)
    const setFuncMap = {
        message, setIsPageLoading, setInviteInfo
    }
    useEffect(() => {
        efn.getInviteInfo(setFuncMap)

    }, [globalData.langChangeTime]);
    return (
        <Spin spinning={isPageLoading}>
            <div className="InviteInfo">
                {inviteInfo.lastUpdateAt && <div className="last-update-at">{`最後更新時間 ${moment(inviteInfo.lastUpdateAt).format("yyyy-MM-DD HH:mm:ss")}`}</div>}
                <div className="main" dangerouslySetInnerHTML={{ __html: inviteInfo.content }}></div>
            </div>
        </Spin>
    );
}



export default InviteInfo;
